module.exports = __webpack_public_path__ + "static/media/S2.0da7d714.png";